import { request } from '@/shared/api/request'

export const editCompany = (params, payload) => {
	return request({ url: '/user/save/company', method: 'POST', data: payload, params })
}
